import { useQuery } from 'react-query';
import axios from 'axios';
import { INDEX_PAGE } from './useInvoices'; // item 1480 — whole index, not a 100-row page
import { ProjectsDto } from '../models/project';

export const getProjects = async (): Promise<ProjectsDto> => {
  const apiUrl = process.env.REACT_APP_BASIX_API || '';
  const { data } = await axios.get(`${apiUrl}project/Index`, { params: { pageSize: INDEX_PAGE } });
  return data;
};

const useProjects = () => useQuery('projects', getProjects);

export default useProjects;
